/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import HinmeiService from "../../service/master/hinmei/hinmeiService"
import { T品名マスタ } from "../../service/master/hinmei/THinmei"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 品名情報検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const HinmeiSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ninusiName?: string
    ninusiCode?: string
    isNinusiReadOnly?: boolean
    setHinmei: (value: T品名マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [品名, set品名] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: {
    荷主コード?: string
    荷主名?: string
    品名?: string
  }) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new HinmeiService().getList({
        品名: searchCondition?.品名,
        荷主名: searchCondition?.荷主名,
        荷主コード: searchCondition?.荷主コード,
      })
      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: T品名マスタ) => {
    props.setHinmei(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      //表示時
      // 荷主コードが設定されている場合、その荷主コードで検索
      if (!wjcCore.isNullOrWhiteSpace(props.ninusiCode ?? "")) {
        set荷主コード(props.ninusiCode)
        set荷主名(props.ninusiName)
        search({ 荷主コード: props.ninusiCode })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set荷主コード("")
      set荷主名("")
      set品名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "品名検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <div className="input-group">
                    <TextInput
                      style={{ width: "6rem" }}
                      autoFocus={true}
                      id="荷主コード"
                      name="荷主コード"
                      value={荷主コード}
                      isReadOnly={props.isNinusiReadOnly}
                      setValue={set荷主コード}
                      maxLength={5}
                      placeholder="荷主CD"
                    />
                    <TextInput
                      style={{ width: "20rem" }}
                      id="荷主名"
                      name="荷主名"
                      value={荷主名}
                      isReadOnly={props.isNinusiReadOnly}
                      setValue={set荷主名}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      placeholder="荷主名"
                    />
                  </div>
                  <TextInput
                    style={{ width: "20rem" }}
                    id="品名"
                    name="品名"
                    value={品名}
                    setValue={set品名}
                    maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                    placeholder="品名"
                  />
                </div>
                <div className="search-condition-row">
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      search({
                        荷主コード,
                        品名,
                      })
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    検索
                  </Button>
                  <Button
                    type="submit"
                    className="ms-4"
                    onClick={(e) => {
                      e.preventDefault()
                      search({
                        荷主コード: CONSTANT.ダミー荷主コード,
                        品名,
                      })
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    共通品名検索
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-end mb-2"></Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<T品名マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="品CD"
                binding="品コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="品名"
                binding="品名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="品名種別"
                binding="品名種別名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={60}
                header="単位"
                binding="単位名称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={100}
                header="単位重量"
                binding="単位容積"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="請求内訳"
                binding="請求内訳"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="危険物"
                dataType={wjcCore.DataType.Boolean}
                binding="危険物フラグ"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default HinmeiSearchModal
